// extracted by mini-css-extract-plugin
export default {"actions":"Clients-module__actions--BshC1","filterActions":"Clients-module__filterActions--m8w_t","filterLabel":"Clients-module__filterLabel--jkXty"};